import { resendVerifyMessage } from "../../../../services/users/auth";
import envelop_opened from "./../../../../images/envelop_opened.png";

import Button from "components/ui/Button";
import { UserContext } from "contexts/UserContext";
import { routes } from "pages/routes";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router";
import Spinner from "components/ui/Spinner";
import { getSuccessComponents } from "../../../../services/util";

import { useRequiredContext } from "contexts/utils";
import { ApiRequestError } from "services/errors";
import styles from "./VerifyEmail.module.scss";
import ApiErrorBanner from "components/ApiErrorBanner";

type Props = {
  email: string;
  token: string;
};

export default function VerifyEmail({ email, token }: Props) {
  const { user, refreshCurrentUser } = useRequiredContext(UserContext);

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<unknown>("");
  const [resendSuccess, setResendSuccess] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [redirect, setRedirect] = useState<string>();

  const handleResend = () => {
    setErrors("");
    setLoading(true);
    resendVerifyMessage({ resend_verification_token: token }).then(
      () => {
        setLoading(false);
        setResendSuccess(true);
      },
      (err: unknown) => {
        if (err instanceof ApiRequestError && err.response?.status === 404) {
          refreshCurrentUser()
            .then(() => {
              // Tiny hack, routes are not updated yet, so have to wait
              // for the next render iteration to redirect user to to the root.
              setRedirect(routes.root.path());
            })
            .catch(() => {
              navigate(routes.public.signIn.path(), {
                state: { error: t("Auth.VerifyNotification.alreadyVerified") },
              });
            });
        } else {
          setErrors(err);
          setLoading(false);
        }
      }
    );
    return email;
  };

  if (redirect) {
    return <Navigate to={redirect} replace />;
  }

  return (
    <div className={styles.step}>
      <h1 className={styles.title}>{t("Auth.verifyEmail.title")}</h1>
      <div className={styles.content}>
        <img className={styles.contentImage} src={envelop_opened} alt="verify-email" />
        <div className={styles.description}>
          <Trans
            i18nKey={"Auth.verifyEmail.description"}
            values={{ email: email || user?.profile.email }}
            components={{ email: <b /> }}
          />
        </div>

        {resendSuccess && getSuccessComponents(t("Auth.verifyEmail.resent"))}

        <div className={styles.forgetQuestion}>{t("Auth.verifyEmail.noEmailPrompt")}</div>
        <ApiErrorBanner error={errors} />
        {loading ? (
          <Spinner />
        ) : (
          <div className={styles.stepAction}>
            <Button
              className={styles.btnOutline}
              variant="secondary"
              size="large"
              onClick={handleResend}
            >
              {t("Auth.verifyEmail.resend")}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
